document.addEventListener("DOMContentLoaded", function () {

  // Desktop only
  if (window.innerWidth < 992) return;

  const floatingButton = document.getElementById("floating-button");

  if (!floatingButton) return;

  floatingButton.classList.add("show");

  const video = floatingButton.querySelector("video");
  const closeButton = floatingButton.querySelector(".fb-close");
  const soundButton = floatingButton.querySelector(".fb-sound");

  // Close button
  if (closeButton) {
    closeButton.addEventListener("click", function () {
      floatingButton.classList.remove("show");

      if (video) {
        video.pause();
      }
    });
  }

  // Sound toggle
  if (soundButton && video) {

    // Start muted
    video.muted = true;

    soundButton.addEventListener("click", function () {

      video.muted = !video.muted;

      if (video.muted) {
        soundButton.innerHTML = "🔇";
      } else {
        soundButton.innerHTML = "🔊";
        video.play();
      }

    });

  }

  // Video click → Sports Bras collection
  if (video) {
    video.style.cursor = "pointer";

    video.addEventListener("click", function () {
      window.location.href = "/collections/sports-bras";
    });
  }

});